<template>
  <div class="page-container">
    <div class="card-panel" style="max-width:720px;margin:0 auto;padding:24px;">
      <div class="brand-header">
        <img src="/corecogn.png" alt="CoRecogN" class="brand-logo">
      </div>

      <div :class="['status-banner', bannerClass]">
        <div>
          <div style="font-size:28px;font-weight:700;">{{ result.status === 'success' ? '验证成功' : '验证失败' }}</div>
          <div style="margin-top:8px;opacity:0.9;">{{ result.status === 'success' ? 'SN码验证通过' : '请查看下方失败原因' }}</div>
        </div>
        <div class="status-symbol">{{ result.status === 'success' ? '✓' : '✕' }}</div>
      </div>

      <el-descriptions :column="1" border>
        <el-descriptions-item label="SN码">{{ result.sn }}</el-descriptions-item>
        <el-descriptions-item label="产品名">{{ result.productName }}</el-descriptions-item>
        <el-descriptions-item label="供应商名">{{ result.vendorName }}</el-descriptions-item>
        <el-descriptions-item label="计划投放日期">{{ result.launchDate }}</el-descriptions-item>
        <el-descriptions-item label="计划投放地区">{{ result.launchRegion }}</el-descriptions-item>
        <el-descriptions-item label="最后一次验证日期">{{ result.lastVerifiedAt || '-' }}</el-descriptions-item>
        <el-descriptions-item label="验证次数">{{ result.verifyCount }}</el-descriptions-item>
      </el-descriptions>

      <div style="margin-top:20px;padding-top:16px;border-top:1px solid #ebeef5;">
        <div style="font-weight:600;margin-bottom:8px;">失败原因</div>
        <div>{{ result.status === 'failed' ? (result.reason || '验证失败') : '无' }}</div>
      </div>

      <div style="margin-top:16px;padding-top:16px;border-top:1px solid #ebeef5;">
        <div style="font-weight:600;margin-bottom:8px;">当前时间</div>
        <div>{{ currentTime }}</div>
      </div>

      <div class="action-row">
        <el-button @click="$router.push('/verify')">返回继续验证</el-button>
        <button v-if="result.authorHomeUrl" class="author-home-btn" type="button" @click="goAuthorHome">
          <img :src="xhsIcon" alt="小红书" class="author-home-icon">
          <span>跳转到作者主页</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifySN } from '../../api/verify'

const xhsIcon = 'data:image/png;base64,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'

export default {
  data() {
    return {
      currentTime: '',
      xhsIcon,
      result: {
        status: 'success',
        reason: '',
        sn: '',
        productName: '',
        vendorName: '',
        launchDate: '',
        launchRegion: '',
        lastVerifiedAt: '',
        verifyCount: 0,
        snStatus: '',
        authorHomeUrl: '',
      },
    }
  },
  computed: {
    bannerClass() {
      if (this.result.status === 'success') {
        return 'success'
      }
      return this.result.snStatus === 'disabled' ? 'failed-danger' : 'failed'
    },
  },
  created() {
    document.title = 'CoRecogN'
    this.currentTime = this.formatNow()
    this.loadResult()
  },
  methods: {
    formatNow() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    async loadResult() {
      const hasPayload = this.$route.query.status || this.$route.query.reason || this.$route.query.productName
      if (hasPayload) {
        this.result = {
          ...this.result,
          ...this.$route.query,
          verifyCount: Number(this.$route.query.verifyCount || 0),
        }
        return
      }
      try {
        const clientId = localStorage.getItem('clientId') || `client-${Math.random().toString(36).slice(2, 10)}`
        localStorage.setItem('clientId', clientId)
        const { data } = await verifySN({
          sn: this.$route.query.sn,
          verifyCode: this.$route.query.verifyCode || this.$route.query.code,
          clientId,
        })
        this.result = data
      } catch (error) {
        const data = error.response?.data || {}
        this.result = {
          ...this.result,
          ...data,
          status: data.status || 'failed',
          reason: data.reason || data.message || '验证失败',
        }
      }
    },
    goAuthorHome() {
      window.open(this.result.authorHomeUrl, '_blank')
    },
  },
}
</script>

<style scoped>
.brand-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.brand-logo {
  width: 180px;
  height: auto;
  object-fit: contain;
}

.status-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  padding: 24px;
  color: #fff;
  margin-bottom: 20px;
}

.status-banner.success {
  background: #67c23a;
}

.status-banner.failed {
  background: #e6a23c;
}

.status-banner.failed-danger {
  background: #f56c6c;
}

.status-symbol {
  font-size: 64px;
  line-height: 1;
  opacity: 0.25;
  font-weight: 700;
}

.action-row {
  margin-top: 20px;
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.author-home-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 40px;
  border: 1px solid #ff2442;
  border-radius: 999px;
  padding: 0 18px;
  background: linear-gradient(135deg, #ff4d67 0%, #ff2442 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(255, 36, 66, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.author-home-btn:hover {
  background: linear-gradient(135deg, #ff3655 0%, #e61e3c 100%);
  box-shadow: 0 12px 24px rgba(255, 36, 66, 0.28);
  transform: translateY(-1px);
}

.author-home-btn:focus-visible {
  outline: 2px solid rgba(255, 36, 66, 0.28);
  outline-offset: 3px;
}

.author-home-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
</style>
